const dialogTitleStyle = {
  fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
  fontSize: 20,
  fontWeight: 400,
  textAlign: "center",
};

const subHeadingStyle = {
  fontFamily: `'Hind', 'Avenir', 'Helvetica', 'arial'`,
  fontSize: 16,
  fontWeight: 300,
  textAlign: "center",
  padding: 10,
};

const boxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: "5px",
  textAlign: "center",
};

const boxStyleNoPadding = {
  ...boxStyle,
  padding: 0,
  borderRadius: "10px",
};

const largeBoxStyleNoPadding = {
  ...boxStyleNoPadding,
  width: 504,
};

const gettingStartedBoxStyle = {
  ...boxStyleNoPadding,
  width: "fit-content",
  outline: 0
}

const createContentBoxStyle = {
  ...gettingStartedBoxStyle, 
  left: "53%",
}

const createContentBoxMobile = {
  ...createContentBoxStyle,
  left: "50%",
  borderRadius: "0px",
}

const arrowBoxStyle = {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    "&::before": {
      backgroundColor: "white",
      content: '""',
      display: "block",
      position: "absolute",
      width: 14,
      height: 14,
      top: -7,
      transform: "rotate(45deg)",
      left: "calc(100% - 56px)",
    }
};

const arrowBoxStyleBottom = {
  ...arrowBoxStyle,
  "&::before": {
    top: 72,
  },
};

const postStatusTreyBoxStyle = {
  width: 485,
  minHeight: 80,
  maxHeight: 600,
  borderRadius: 2,
  backgroundColor: "white",
  padding: "10px",
  boxShadow: 2,
};

const postStatusTreyBoxStyleBottom = {
  ...postStatusTreyBoxStyle,
  mr: "72px",
};

const postBar = {
  width: "100%",
  height: 25,
  borderRadius: 5,
  padding: "10px",
};

const postProgressBar = {
  height: 21,
  borderRadius: 5,
  padding: "10px",
  border: 0,
  marginLeft: 0.1,
  backgroundImage:
    "repeating-linear-gradient(45deg, #B3E3D0, #B3E3D0 10px, #00A15D 10px, #00A15D 20px)",
};

const genericModalBoxStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 290,
  bgcolor: "background.paper",
  boxShadow: 24,
  padding: "1em",
  borderRadius: "5px",
  textAlign: "center",
  boxShadow: "4px 4px 8px 0px #DEE1F7",
}

export {
  dialogTitleStyle,
  subHeadingStyle,
  boxStyle,
  arrowBoxStyle,
  postStatusTreyBoxStyle,
  postBar,
  postProgressBar,
  boxStyleNoPadding,
  largeBoxStyleNoPadding,
  arrowBoxStyleBottom,
  postStatusTreyBoxStyleBottom,
  gettingStartedBoxStyle,
  createContentBoxStyle,
  createContentBoxMobile,
  genericModalBoxStyle
};
